// extracted by mini-css-extract-plugin
export default {"text-banner":"Banner_text-banner__qQpxC"};